var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-fill flex-column"},[_c(_vm.item.component,_vm._b({tag:"component",on:{"go":_vm.go}},'component',_vm.item.attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }